import { render } from "./Notepad.vue?vue&type=template&id=998a60ca&scoped=true&ts=true"
import script from "./Notepad.vue?vue&type=script&lang=ts"
export * from "./Notepad.vue?vue&type=script&lang=ts"

import "./Notepad.vue?vue&type=style&index=0&id=998a60ca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-998a60ca"]])

export default __exports__